// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer{margin-bottom:1rem;margin-top:5rem;text-align:center}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/footer/styles.scss"],"names":[],"mappings":"AAAA,OACE,kBAAA,CACA,eAAA,CACA,iBAAA","sourcesContent":["footer {\r\n  margin-bottom: 1rem;\r\n  margin-top: 5rem;\r\n  text-align: center;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
